import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForStorageHardLimit(context: EditionAwarenessContextType): boolean {
	const {
		storageUsageInGB,
		storageLimitInGB,
		storageIsUnlimited,
		product,
		edition,
		isInCollection,
		canUpgrade,
		canDirectBuyUpgrade,
	} = context;

	if (!storageUsageInGB || !storageLimitInGB) {
		return false;
	}

	if (fg('ea_audience_and_timing_refactor')) {
		return Boolean(
			!isInCollection &&
			product === 'jira' &&
			edition === 'free' &&
			(canUpgrade || canDirectBuyUpgrade) &&
			!storageIsUnlimited &&
			storageUsageInGB >= storageLimitInGB,
		);
	}

	return (
		!isInCollection &&
		product === 'jira' &&
		edition === 'free' &&
		!storageIsUnlimited &&
		storageUsageInGB >= storageLimitInGB
	);
}
